import React from 'react';
import { Y500 } from '@assets/colors';
import { number, oneOfType, string } from 'prop-types';

const IconWarning = ({ color, size, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <circle
      cx="8"
      cy="11.25"
      r="0.75"
      transform="rotate(-180 8 11.25)"
      fill={color}
    />
    <path d="M8 9L8 7" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M2 13L8.11378 3L14 13H2Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

IconWarning.propTypes = {
  color: string,
  size: oneOfType([string, number]),
};

IconWarning.defaultProps = {
  color: Y500,
  size: 16,
};

export default IconWarning;
